import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setShareResultsSettings, useReviewCreationData, useShareResultsSettings } from 'reducers/reviewCreationSlice';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { RadioSelectGroup } from 'uiToolkitV1/RadioSelectGroup';
import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ShareResultsSettings, useTemplateMetadata } from '../../../Hooks/dataHooks/shareResultsDataHooks';

export const AnonymousSettings = ({ feedbackFormId }) => {
  const settings: ShareResultsSettings = useShareResultsSettings({ feedbackFormId });
  const { reviewCycleId } = useReviewCreationData();
  const dispatch = useDispatch();

  const hasPeer = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.PEER,
  });
  const hasUpward = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.UPWARD,
  });

  if (!hasPeer && !hasUpward) {
    return null;
  }

  const showPeerAnswers = settings.isShowPeerAnswers;

  const radioOptions = [];
  const selectedIndices = [];
  if (hasPeer) {
    radioOptions.push({
      rowId: 'peer',
      type: 'Peer',
      options: [
        {
          name: 'Show names',
          isDisabled: !showPeerAnswers,
        },
        {
          name: 'Keep anonymous',
          isDisabled: !showPeerAnswers,
        },
      ],
    });
    selectedIndices.push(settings.isAnonymizePeers ? 1 : 0);
  }
  if (hasUpward) {
    radioOptions.push({
      rowId: 'upward',
      type: 'Upward',
      options: [
        {
          name: 'Show names',
          isDisabled: true,
        },
        {
          name: 'Keep anonymous',
          isDisabled: true,
        },
      ],
    });
    selectedIndices.push(1); // upward always anonymous
  }

  const onChange = (index: number, optionIndex: number) => {
    if (hasPeer) {
      if (index === 0) {
        dispatch(
          setShareResultsSettings({
            feedbackFormId,
            settings: { isAnonymizePeers: optionIndex === 1 },
          })
        );
      } else {
        dispatch(
          setShareResultsSettings({
            feedbackFormId,
            settings: { isAnonymizeUpward: optionIndex === 1 },
          })
        );
      }
    } else {
      dispatch(
        setShareResultsSettings({
          feedbackFormId,
          settings: { isAnonymizeUpward: optionIndex === 0 },
        })
      );
    }
  };

  return (
    <Flex flexDir="column" gap={3}>
      <Flex alignItems="center" gap={2}>
        <TextBodyMedium>Can self see the names of the peer/upward reviewers?</TextBodyMedium>
        <TooltipInfoV1 title="Post the review publish, visibility of peer or upward names to the employees" />
      </Flex>
      <RadioSelectGroup
        headers={['Reviewer types', 'Name Visibility']}
        data={radioOptions}
        onChange={onChange}
        selectedIndexList={selectedIndices}
      />
    </Flex>
  );
};
